"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _stores = require("@seedlang/stores");
var _utils = require("@seedlang/utils");
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var SentenceStudioUI = (_class = /*#__PURE__*/function (_RootState) {
  function SentenceStudioUI() {
    var _this;
    _classCallCheck(this, SentenceStudioUI);
    _this = _callSuper(this, SentenceStudioUI);
    _initializerDefineProperty(_this, "selectedTranslation", _descriptor, _this);
    _initializerDefineProperty(_this, "selectedTranslationType", _descriptor2, _this);
    _initializerDefineProperty(_this, "videoClip", _descriptor3, _this);
    _initializerDefineProperty(_this, "sentenceId", _descriptor4, _this);
    _initializerDefineProperty(_this, "deviceDeniedAccess", _descriptor5, _this);
    _initializerDefineProperty(_this, "autoAdvanceWord", _descriptor6, _this);
    _initializerDefineProperty(_this, "overwriteVideo", _descriptor7, _this);
    _initializerDefineProperty(_this, "reset", _descriptor8, _this);
    _initializerDefineProperty(_this, "getSentence", _descriptor9, _this);
    _this.getCookieValue = function (name) {
      return _this.cookieStore.getCookieValue(name);
    };
    _initializerDefineProperty(_this, "afterGetSentence", _descriptor0, _this);
    _initializerDefineProperty(_this, "onPlayVideoFromTranslation", _descriptor1, _this);
    _initializerDefineProperty(_this, "onSetVideoableFromTranslation", _descriptor10, _this);
    _initializerDefineProperty(_this, "onDeleteVideoClip", _descriptor11, _this);
    _initializerDefineProperty(_this, "afterDeleteVideoClip", _descriptor12, _this);
    _initializerDefineProperty(_this, "afterCreateRequestSent", _descriptor13, _this);
    _initializerDefineProperty(_this, "onDeleteSentence", _descriptor14, _this);
    _initializerDefineProperty(_this, "onSetDefault", _descriptor15, _this);
    _this.loadSentence = function (id) {
      _this.reset();
      _this.sentenceStore.getShow({
        ids: {
          sentenceId: id,
          expanded: true
        }
      }, _this.afterGetSentence.bind(_this));
    };
    _this.authUserStore = _stores.AuthUserStore;
    _this.sentenceStore = _stores.SentenceStore;
    _this.videoClipStore = _stores.VideoClipStore;
    _this.cookieStore = _stores.CookieStore;
    return _this;
  }
  _inherits(SentenceStudioUI, _RootState);
  return _createClass(SentenceStudioUI, [{
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "sentence",
    get: function get() {
      return this.sentenceStore.showData;
    }
  }, {
    key: "hasSentence",
    get: function get() {
      return this.sentenceStore.hasShowData;
    }
  }, {
    key: "currentTranslationTargetIsWord",
    get: function get() {
      if ((0, _utils.isBlank)(this.currentTranslationTarget)) {
        return false;
      }
      return this.currentTranslationTarget.text && (0, _utils.isBlank)(this.currentTranslationTarget.text.match(' '));
    }
  }, {
    key: "translationType",
    get: function get() {
      return this.selectedTranslationType || this.derivedTranslationType;
    }
  }, {
    key: "currentTranslation",
    get: function get() {
      // auto advance needs to contend with this
      return (0, _utils.isPresent)(this.selectedTranslation) ? this.selectedTranslation : this.sentence.firstUnrecordedTranslation;
    }
  }, {
    key: "foreignKey",
    get: function get() {
      if (this.translationType === 'correct') {
        return 'correct_video_clip_id';
      }
      if (this.translationType === 'incorrect') {
        return 'incorrect_video_clip_id';
      }
      return null;
    }
  }, {
    key: "derivedTranslationType",
    get: function get() {
      if (this.firstUnrecordedTarget && this.firstUnrecordedTarget.id === this.sentence.target.id && this.sentence.target.hasVideoClipOrRecorded) {
        if ((0, _utils.isBlank)(this.sentence.correctVideoClip) && !this.sentence.correctVideoUploading) {
          return 'correct';
        }
        if ((0, _utils.isBlank)(this.sentence.incorrectVideoClip) && !this.sentence.incorrectVideoUploading) {
          return 'incorrect';
        }
      }
      return null;
    }
  }, {
    key: "currentTranslationTarget",
    get: function get() {
      return (0, _utils.isPresent)(this.currentTranslation) ? this.currentTranslation.target : {};
    }
  }, {
    key: "firstUnrecordedTarget",
    get: function get() {
      return this.sentence.firstUnrecordedTarget;
    }
  }, {
    key: "videoableId",
    get: function get() {
      if (['correct', 'incorrect'].includes(this.translationType)) {
        return this.sentence.id;
      }
      if (this.currentTranslationTarget) {
        return this.currentTranslationTarget.id;
      }
    }
  }, {
    key: "createVideoClipStore",
    value: function createVideoClipStore() {
      this.videoClipRecorderStore = new _stores.VideoRecorderStore({
        parent: this
      });
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "selectedTranslation", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedTranslationType", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "videoClip", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "sentenceId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "deviceDeniedAccess", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "autoAdvanceWord", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.getCookieValue('auto_advance_word');
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "overwriteVideo", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.getCookieValue('overwrite_video');
  }
}), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sentence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSentence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentTranslationTargetIsWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentTranslationTargetIsWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "translationType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "translationType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentTranslation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentTranslation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "foreignKey", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "foreignKey"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "derivedTranslationType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "derivedTranslationType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentTranslationTarget", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentTranslationTarget"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstUnrecordedTarget", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstUnrecordedTarget"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "videoableId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "videoableId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createVideoClipStore", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "createVideoClipStore"), _class.prototype), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "reset", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function () {
      _this2.selectedTranslation = {};
      _this2.selectedTranslationType = null;
      _this2.videoClip = null;
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "getSentence", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (callback) {
      _this3.sentenceStore.getShow({
        ids: {
          sentenceId: _this3.sentenceId,
          expanded: true
        }
      }, function (resp) {
        return _this3.afterGetSentence.bind(_this3)(resp, callback);
      });
    };
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "afterGetSentence", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (resp, callback) {
      _this4.sentenceStore.setShowData(resp);
      if ((0, _utils.isPresent)(callback)) {
        callback(resp);
      }
    };
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "onPlayVideoFromTranslation", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return function (translation, translationType) {
      if ((0, _utils.isPresent)(_this5.videoClip) && _this5.selectedTranslation === translation && _this5.selectedTranslationType == translationType) {
        _this5.reset();
      } else if ((0, _utils.isPresent)(translation)) {
        _this5.selectedTranslation = translation;
        _this5.selectedTranslationType = translationType;
        if (!translationType || translationType === 'neutral') {
          _this5.videoClip = translation.target.videoClip;
        } else if (translationType === 'correct') {
          _this5.videoClip = translation.correctVideoClip;
        } else if (translationType === 'incorrect') {
          _this5.videoClip = translation.incorrectVideoClip;
        }
      }
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "onSetVideoableFromTranslation", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function (translation, translationType) {
      if ((0, _utils.isBlank)(_this6.videoClip) && _this6.selectedTranslation === translation && _this6.selectedTranslationType == translationType) {
        _this6.selectedTranslationType = null;
        _this6.selectedTranslation = {};
      } else {
        _this6.selectedTranslationType = translationType;
        _this6.selectedTranslation = translation;
      }
      _this6.videoClip = null;
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "onDeleteVideoClip", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;
    return function (id, callback) {
      _this7.afterDeleteVideoClipCallback = callback;
      _this7.videoClipStore.destroy({
        ids: {
          videoClipId: id
        }
      }, _this7.afterDeleteVideoClip);
      _this7.reset();
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "afterDeleteVideoClip", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;
    return function () {
      if (_this8.afterDeleteVideoClipCallback) {
        _this8.afterDeleteVideoClipCallback();
      }
      _this8.getSentence();
    };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "afterCreateRequestSent", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;
    return function () {
      if ((0, _utils.isPresent)(_this9.currentTranslationTarget) && !_this9.translationType) {
        _this9.currentTranslationTarget.set('videoClipUploading', true);
        _this9.currentTranslationTarget.videoClip = {};
      } else if ((0, _utils.isPresent)(_this9.currentTranslation) && _this9.translationType === 'correct') {
        _this9.currentTranslation.set('correctVideoUploading', true);
      } else if ((0, _utils.isPresent)(_this9.currentTranslation) && _this9.translationType === 'incorrect') {
        _this9.currentTranslation.set('incorrectVideoUploading', true);
      }
    };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "onDeleteSentence", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this0 = this;
    return function (id) {
      _this0.sentenceStore.destroy({
        ids: {
          sentenceId: id
        }
      });
    };
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "onSetDefault", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this1 = this;
    return function (item) {
      if (!item["default"]) {
        _this1.videoClipStore.update({
          ids: {
            videoClipId: item.id
          },
          data: {
            "default": true
          }
        }, _this1.getSentence);
      }
    };
  }
}), _class);
var _default = exports["default"] = new SentenceStudioUI();